import { NetworkTableconstant } from "./NetworkTableConstant";

const NetworkTableAction = {};

NetworkTableAction.getNetworkTable = ({
  to_date ,
  from_date ,
  search_term,
  limit ,
  page ,
} = {}) => {
  return {
    type: NetworkTableconstant.NETWORK_TABLE_SAGA,
    payload: {
      to_date: to_date,
      from_date: from_date,
      search_term: search_term,
      limit: limit,
      page: page
    }
  };
};


// ********POST*******
NetworkTableAction.postChargingNetworkAction = (payload) => {
  return {
    type: NetworkTableconstant.POST_ADD_CHARGING_NETWORK_SAGA,
    payload: payload,
  };
};
//*****enable disable charging network */

NetworkTableAction.AddChargingNetworkEnableDisable = ({ id, status }) => {
  return {
    type: NetworkTableconstant.ENABLE_DESABLE_CHARGING_NETWORK_SAGA,
    payload: { id, status },
  };
};

//UPDATA CGARGING NETWORK
NetworkTableAction.UdateChargingNetworkAction = (payload) => {
  return {
    type: NetworkTableconstant.UPDATE_CHARGING_NETWORK_SAGA,
    payload: payload,
  };
};

export { NetworkTableAction };
